const shadows = {
  depth1: '0 8px 13px 0 rgba(0,0,0,0.13)',
  depth2: '0 2px 23px 0 rgba(162,162,162,0.12)',
};

export default shadows;
